import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { v2api } from './axios';
import Log from '../lib/log';

dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.tz.setDefault('Asia/Tokyo');

// ログの初期化
const log = new Log('sendMail');

/**
 * 解約受付メールの送信
 * @param id ユーザーID
 * @param token ユーザートークン
 * @param address 送信先メールアドレス
 * @returns 
 */
const sendDeletedMail = async (
  id: string | undefined, token: string | undefined, address: string | undefined) => {
  if (!address) return false;

  const formattedDate = dayjs()
    .tz()
    .format('YYYY年MM月DD日 HH時mm分');
  // メール送信
  const htmlBody = `
<h3>解約を受け付けました</h3><hr />
<p>受付日時: ${formattedDate}</p>
<hr />
<h4>今後の流れについて</h4>
<p>今月末日の正午までは通常通りご利用いただくことができます。<br />
今月末日の正午を持ちまして、払い出させていただきました050番号は無効になります。<br />
お手数ですが、転送設定をされている場合はそれまでに解除をお願いいたします。</p>
<h4>データについて</h4>
<p>今月末日の正午を持ちまして、お預かりしていた録音データにつきましては削除されます。<br />
ただし、お客様のご契約番号ならびに、カード決済情報につきましては120日間は保持されます。</p>
<h4>再契約について</h4>
<p>今月末日の解約時点から120日間は、同じ番号での再契約はできません。</p>
<h4>解約の取り消しについて</h4>
<p>解約の取り消しをご希望の場合は、お手数ですがサポート宛てにお問い合わせください。<br />
<a href='https://transrec.zendesk.com/hc/ja/requests/new'>サポート窓口</a><br />
なお、今月末日の正午を超えての解約取り消しはできませんので、あしからずご了承ください。</p>
<hr />
<p>※本メールは送信専用です。返信はできませんのでご了承ください。</p>
  `;
  const textBody = `
解約を受け付けました\r\n
------------------------------------\r\n
受付日時: ${formattedDate}\r\n
------------------------------------\r\n
今後の流れについて\r\n
今月末日の正午までは通常通りご利用いただくことができます。\r\n
今月末日の正午を持ちまして、払い出させていただきました050番号は無効になります。\r\n
お手数ですが、転送設定をされている場合はそれまでに解除をお願いいたします。\r\n\r\n
データについて\r\n
今月末日の正午を持ちまして、お預かりしていた録音データにつきましては削除されます。\r\n
ただし、お客様のご契約番号ならびに、カード決済情報につきましては120日間は保持されます。\r\n\r\n
再契約について\r\n
今月末日の解約時点から120日間は、同じ番号での再契約はできません。\r\n\r\n
解約の取り消しについて\r\n
解約の取り消しをご希望の場合は、お手数ですがサポート宛てにお問い合わせください。\r\n
https://transrec.zendesk.com/hc/ja/requests/new\r\n
なお、今月末日の正午を超えての解約取り消しはできませんので、あしからずご了承ください。\r\n
------------------------------------\r\n
※本メールは送信専用です。返信はできませんのでご了承ください。\r\n
  `;

  // メール送信
  const postData = {
    userId: id,
    token,
    address,
    subject: '[TRANSREC]解約を受付ました。',
    htmlBody,
    textBody,
  };
  try {
    await v2api.post('/send-mail', postData);
    log.putLog('info', 'Mail sent.');
    return true;
  } catch (err) {
    log.putLog('error', 'Send error.');
    return false;
  }
}

export { sendDeletedMail };